<template>
   <nav>
       <v-app-bar  color="#28a745" dark app >
           <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
           <v-toolbar-title class="text-uppercase ">
               <span class="font-weight-light">CỔNG THÔNG TIN</span>
               <span> ETC PORTAL</span>
           </v-toolbar-title>
           <v-spacer></v-spacer>
           <template v-if="isAuthorized">
               <v-menu
                v-model="notificationMenu"
                :close-on-content-click="false"
                :nudge-width="250"
                offset-y
               >
                    <template v-slot:activator="{ on, attrs }">
                        <!-- <notification-bell
                            :size="25"
                            :count="notificationsCount"
                            :ding="true"
                            :upperLimit=50
                            counterLocation="upperRight"
                            counterStyle="roundRectangle"
                            counterBackgroundColor="#FF0000"
                            counterTextColor="#FFFFFF"
                            iconColor="orange"
                            :animated="true"
                            :prefixPlus="true"
                            v-bind="attrs"
                            v-on="on"
                        /> -->
                            <v-btn
                                color="orange"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                text
                            >
                            <v-badge overlap color="red" :content=notificationsCount v-if=notificationsCount>
                                <v-icon dark>
                                    mdi-bell
                                </v-icon>
                            </v-badge>
                            <v-icon dark v-else>
                                mdi-bell
                            </v-icon>
                            </v-btn>
                    </template>
                    <v-card>
                        <v-list>
                        <template  v-for="(data) in notifications">
                            <v-list-item :key=data.message v-if=data.show>
                                <v-list-item-content>
                                    <v-list-item-title><v-btn text color="green" small @click="LoadPage(data)">{{data.message}}</v-btn></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        </v-list>
                    </v-card>
               </v-menu>
                <v-btn text @click="onLogout">
                    <span>Thoát</span>
                    <v-icon right>exit_to_app</v-icon>
                </v-btn>
           </template>
       </v-app-bar>
      <v-navigation-drawer v-model="drawer" dark app color="#008a43" v-if="isAuthorized">
          <v-layout column align-center>
               <v-flex class="mt-5"> 
                    <img src="/logo-trang.png" alt="" height="111">
                    <p class="white--text subheading mt-1 text-center"><strong>ETC ĐÔNG HÀ</strong></p>
               </v-flex>
          </v-layout>
          <v-list>
              <v-list-item v-for="link in links"  :key="link.text" router :to="link.route" active-class="border">
                  <v-list-item-action>
                     <v-icon >{{link.icon}}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content >
                      <v-list-item-title >{{link.text}}</v-list-item-title>
                  </v-list-item-content>
              </v-list-item>
          </v-list>
      </v-navigation-drawer>
   </nav>
</template>
<script>
// import NotificationBell from 'vue-notification-bell'
import {mapGetters} from 'vuex'
export default {
    computed: {
        ...mapGetters(['authStatus','isAuthenticated']),
        isAuthorized(){
            if(this.authStatus ==="success" || this.isAuthenticated){
                return true;
            }
            return false;
        }
    },
    data: () => ({
      notificationMenu:false,
      notificationsCount: 0,
      notifications: [],
      drawer: true,
      links :[
          {icon: 'mdi mdi-message-text', text:'Vượt Trạm', route: '/'},
          {icon: 'mdi mdi-dialpad', text:'Vé tháng', route: '/ve-thang'},
          {icon: 'mdi-license', text:'Giấy tờ xe', route: '/giay-to-xe'}
      ]
     
    }),
    components: {
        // NotificationBell
    },
    methods:{
        LoadPage(data){
            this.$router.push(data.link).catch(()=>{});
        },
        onLogout() {
            this.$store.dispatch('AUTH_LOGOUT');
        },
        Notification(){
            if(this.authStatus === "success" || this.isAuthorized){
                this.$Request.get('/notifications').then(response=>{
                    const json = response.data;
                    if(json.success === true){
                        this.notificationsCount = json.data.number;
                        this.notifications = json.data.notifications;
                    }
                });
            }
            setTimeout(this.Notification,10000);
        }
    },
    mounted(){
        this.Notification();
    }
   
}
</script>
<style scoped>
.border {
  border-left: 4px solid #0ba518;
}
</style>
